import { batchDeleteFieldInstances } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { BatchDeleteInput } from "db/definitions";
import { recordSentry } from "utils/recordSentry";

async function batchRemoveFieldInstances(fieldInstances: BatchDeleteInput[]): Promise<boolean> {
	if (fieldInstances.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchDeleteFieldInstances,
				variables: { fieldInstances },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchRemoveFieldInstances;
